// グラフの共通テーマを Chart.defaults に設定する（トラッカー G1）。
// 中身は utils/chartTheme.js（CMP と会員アプリで同じ内容）。各グラフの個別指定が優先される
import Chart from 'chart.js'
import { applyChartDefaults } from '~/utils/chartTheme'

export default () => {
  applyChartDefaults(Chart)
}
